import React from "react";
import { Row, Col } from "antd";
import { CloseOutlined, WarningOutlined } from "@ant-design/icons";
import { Modal, Button as StrapButton } from "reactstrap";



const ErrorAlertModal = ({ isOpen, title, subtitle, onClose, onConfirm }) => {


    return (
        <Modal
            centered
            fade={false}
            destroyOnClose
            isOpen={isOpen}
            modalClassName="p-2"
            style={{ minWidth: "15%" }}
            onClosed={onClose}
        >
            <Row gutter={24} className="p-4">
                <Col span={24}>
                    <Row gutter={24} className="mb-3">
                        <Col span={24} className="text-center" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <div className="text-center icon-container-delete" style={{ backgroundColor: "#fff7e7", border: "1px solid #f1b44c", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <WarningOutlined style={{ fontSize: "25px", fontWeight: "bold", color: "#f1b44c" }} />
                            </div>
                        </Col>
                    </Row>
                    <Row gutter={24} className="mt-4">
                        <Col xl={3} lg={2} md={0} sm={0} xs={0} />
                        <Col xl={18} lg={20} md={24} sm={24} xs={24} className="text-center">
                            <h5 style={{ fontSize: "18px" }}>{title}</h5>
                            <p style={{ fontSize: "16px" }}>{subtitle}</p>
                        </Col>
                    </Row>
                    <Row gutter={24} className="mt-3">
                        <Col xl={6} lg={6} md={5} sm={0} xs={0} />
                        <Col xl={12} lg={12} md={14} sm={24} xs={24}>
                            <StrapButton
                                outline
                                color="warning"
                                onClick={onClose}
                                className="w-100 d-flex align-items-center justify-content-center"
                            >
                                <CloseOutlined className="mr-2" />
                                Mbyll
                            </StrapButton>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Modal>
    );
};

export default ErrorAlertModal;